import { useEffect, useState } from "react";

/**
 * Pixels of the layout viewport covered below the visual viewport (e.g. mobile
 * software keyboard). Use extra bottom padding on fixed full-screen footers.
 */
export function useVisualViewportBottomOverlap(enabled: boolean): number {
  const [px, setPx] = useState(0);

  useEffect(() => {
    if (!enabled || typeof window === "undefined") {
      setPx(0);
      return;
    }

    const vv = window.visualViewport;
    if (!vv) {
      setPx(0);
      return;
    }

    const update = () => {
      setPx(Math.max(0, window.innerHeight - vv.height - vv.offsetTop));
    };

    update();
    vv.addEventListener("resize", update);
    vv.addEventListener("scroll", update);
    return () => {
      vv.removeEventListener("resize", update);
      vv.removeEventListener("scroll", update);
    };
  }, [enabled]);

  return px;
}
